import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import Register from "./Pages/Register";
import ClubLocation from "./Pages/ClubLocation";
// import ShopDetail from "./Pages/ShopDetail";
import SetPassword from "./Pages/SetPassword";
import Summary from "./Pages/Summary";
import CardDetail from "./Pages/CardDetail";
import ThankYouPage from "./Pages/ThankYouPage";
import { LoadScript } from "@react-google-maps/api";
import PaymentFailed from "./Pages/PaymentFailed";
import PaymentPending from "./Pages/PaymentPending";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsService from "./Pages/TermsService";
import ContactUs from "./Pages/ContactUs";
import PasswordUpdateSuccess from "./Pages/PasswordUpdateSuccess";
import CheckDeviceType from "./Pages/CheckDeviceType";
function App() {
  return (
    <div className="App">
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={["places"]}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="register" element={<Register />} />
            <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
            <Route path="/reset-password" element={<ResetPassword />}></Route>

            <Route path="club-location" element={<ClubLocation />} />
            {/* <Route path="shop-detail" element={<ShopDetail />} /> */}
            <Route path="/payment-pending" element={<PaymentPending />}></Route>
            <Route path="/payment-failed" element={<PaymentFailed />}></Route>
            <Route path="set-password" element={<SetPassword />} />
            <Route path="summary" element={<Summary />} />
            <Route path="stripe-success" element={<CardDetail />} />
            <Route path="thank-you" element={<ThankYouPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms-and-conditions" element={<TermsService />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="success" element={<PasswordUpdateSuccess />} />
            <Route
              path="check-devicetype/:userType"
              element={<CheckDeviceType />}
            />
          </Routes>
        </BrowserRouter>
      </LoadScript>
    </div>
  );
}

export default App;
